import { gql } from "@apollo/client";
import useWrappedMutation from "../../common/data-fetching/useWrappedMutation";

const QUERY_SCOPE = "jobAdmin";
const QUERY_NAME = "jobAdminUpdate";

export const QUERY = gql`
    mutation ${QUERY_SCOPE}_${QUERY_NAME} (
        $id: ID!,
        $status: JobStatusEnum
        $paymentStatus: JobPaymentStatusEnum
    ) {
      ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
          id: $id,
          status: $status
          paymentStatus: $paymentStatus
        ) {
          _id
          status
          paymentStatus
          datePosted
        }
      }
    }
  `;

export default function useMutationJobUpdate() {
  return useWrappedMutation(QUERY, QUERY_SCOPE, QUERY_NAME);
}
